export const Menu = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
      stroke="currentColor"
      strokeWidth="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M0, 20 Q50, 20 100, 20"></path>
      <path d="M0, 40 Q50, 40 100, 40"></path>
      <path d="M0, 60 Q50, 60 100, 60"></path>
      <path d="M60, 80 Q50, 80 100, 80"></path>
    </svg>
  )
}
